import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { animateScroll } from "react-scroll";
import "react-datepicker/dist/react-datepicker.css";
import { useMediaQuery } from "react-responsive";
import { Modal } from "react-materialize";
import WalletAddBank from "./children/WalletAddBank";
import {
  addedBankDetailsAction,
  getWalletAction,
} from "../../../redux/action/wallet";
import Withdrawals from "./components/Withdrawals";
import { Tabs, Tab } from "react-materialize";
import RecentTransactions from "./components/RecentTransactions";
import SpinnersLoading from "../../loader/SpinnersLoading";
import BankDetailInHomePage from "./children/BankDetailInHomePage";
import BankTransfer from "./components/BankTransfer";
import EmdTranscation from "./components/EmdTranscation";

function Wallet() {
  const dispatch = useDispatch();
  const { wallet, loading } = useSelector((state) => state.wallet);
  const { loadings } = useSelector((state) => state.addBank);
  const isLabtop = useMediaQuery({ query: "(max-width: 1400px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 450px)" });
  const [showWallet, setShowWallet] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    animateScroll.scrollToTop({ smooth: true });
  });

  useEffect(() => {
    dispatch(getWalletAction());
  }, [dispatch]);

  if (loading) {
    return (
      <div>
        <h4>Wallet</h4>
        <SpinnersLoading />
      </div>
    );
  }

  function addBankDataFetching(obj) {
    dispatch(addedBankDetailsAction(obj))
      .then(() => dispatch(getWalletAction()))
      .then(() => {
        const locationModal = document.getElementById("modalAccount");
        const instance = window.M.Modal.getInstance(locationModal);
        instance.close();
      });
  }

  return (
    <div className="mt-1">
      <h4>Wallet</h4>

      <div
        className={`mt-1 wallet-container mb-2 full-width  flex ${isTablet ? "column" : ""
          }`}
      >
        <div
          className={`cover  full-width   mr-1 valign-wrapper p-2 slide-in${isLabtop && "column full-width justify-center "
            } ${isTablet && "mb-1"} gap-2`}
          style={{
            width: isTablet ? "100%" : "50%",

            backgroundColor: showWallet ? "white" : "#E1EEF2",
          }}
        >
          {showWallet ? (
            <div
              className={` full-width white mr-1 ${isLabtop
                  ? "p-1 flex column gap-1"
                  : "p-2 valign-wrapper justify-center gap-2"
                } slide-in${isLabtop && "column full-width justify-center "} ${isTablet && "mb-1"
                } `}
            >
              <div
                className={`cover  border valign-wrapper gap-1  justify-center `}
                style={{
                  width: isLabtop ? "100%" : "370px",
                  height: "125px",
                }}
              >
                <img
                  className="circle border"
                  style={{ padding: "16px", backgroundColor: "#f6ecff " }}
                  src={`${process.env.PUBLIC_URL}/icons/wallet-2.svg`}
                  alt="Icon"
                />

                <span>
                  <b className="cercle-purple-text font-20px">Wallet Balance</b>
                  <p
                    className="black-text font-25px font-cercular-bold"
                    style={{ marginTop: "-5px" }}
                  >
                    {" "}
                    ₹ {wallet?.availableBalance || "000"}
                  </p>
                </span>
              </div>
              <span className="flex justify-center gap-1 column ">
                <button
                  className="border-1px border-radius-12 valign-wrapper justify-center gap-1"
                  style={{
                    height: "55px",
                    width: isLabtop ? "100%" : "300px",
                  }}
                  id="rzp-button1"
                  onClick={() => setShowWallet(false)}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/icons/groupIcon.svg`}
                    alt="Icon"
                  />
                  <span className="font-18px" style={{ marginTop: "2px" }}>
                    Recharge
                  </span>
                </button>

                <button
                  className="border-1px border-radius-12 valign-wrapper justify-center gap-1"
                  style={{ height: "55px", width: isLabtop ? "100%" : "300px" }}
                  onClick={() => navigate("/wallet/add-money")}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/icons/bank.svg`}
                    alt="Icon"
                  />
                  <span className="font-18px" style={{ marginTop: "2px" }}>
                    Withdraw
                  </span>
                </button>
              </span>
            </div>
          ) : (
            <BankTransfer setShowWallet={setShowWallet} virtualAccountNumber={wallet?.virtualAccountNumber} />
          )}
        </div>
        {/* <RechargeProcesser setShowWallet={setShowWallet} /> */}
        <div
          className="cover full-width white "
          style={{ width: isTablet ? "100%" : "50%" }}
        >
          <div className="valign-wrapper space-between p-1">
            <span className="valign-wrapper gap-1">
              <img
                src={`${process.env.PUBLIC_URL}/icons/bank.svg`}
                alt="Icon"
              />
              <span
                className={`${isMobile ? "font-16px" : "font-20px"
                  } cercle-purple-text`}
                style={{ marginTop: "5px" }}
              >
                Your Bank Accounts
              </span>
            </span>
            <button
              className={`modal-trigger white valign-wrapper ${isMobile ? "font-16px" : "font-18px"
                }  pointer bold  border-radius-12`}
              style={{
                padding: isMobile ? "0.5rem" : "0.5rem 1rem",
                border: "1px dashed black",
              }}
              href="#modalAccount"
            >
              <span className="material-symbols-outlined">add</span>
              <p className="">Add Bank</p>
            </button>
          </div>
          <hr />

          {wallet?.bankAccounts
            ?.slice(-2)
            .reverse()
            .map((item, index) => {
              return <BankDetailInHomePage item={item} key={index} />;
            })}

          {wallet?.bankAccounts?.length > 2 && (
            <p
              className="flex justify-center mt-1 mb-1 cercle-purple-text pointer"
              style={{ textDecoration: "underLine" }}
              onClick={() => navigate("/wallet/wallet-account")}
            >
              View all
            </p>
          )}
          {wallet?.bankAccounts?.length === 0 && (
            <p className="valign-wrapper justify-center mt-3 cercle-purple-text pointer">
              No Bank Account Added
            </p>
          )}
        </div>
      </div>

      <Tabs>
        <Tab title="Recent Transactions">
          <RecentTransactions />
        </Tab>

        <Tab title="Withdrawals">
          <Withdrawals />
        </Tab>
        <Tab title="Emd Transcation">
          <EmdTranscation />
        </Tab>
      </Tabs>

      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalAccount"
        open={false}
      >
        <WalletAddBank
          addBankDataFetching={addBankDataFetching}
          loadings={loadings}
        />
      </Modal>
    </div>
  );
}

export default Wallet;
